<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <h2 class="h-text">{{$t('message.Users')}}</h2>
        <b-row class="px-4">
          <b-col md="4">
            <label style="margin-left: 60px">{{$t('message.Role')}}</label>
            <b-form-select
                style="margin-left: 60px"
                v-model="role_id"
                :options="roles"
                text-field="display_name"
                value-field="id"
                class="form-select w-75"
                @input="fetchUsers"
                aria-label="Default select example"></b-form-select>
          </b-col>
<!--          <b-col md="4">-->
<!--            <label>Ko'rsatish bo'yicha</label>-->
<!--            <b-form-select-->
<!--                v-model="selected"-->
<!--                :options="options"-->
<!--                class="form-select w-75"-->
<!--                aria-label="Default select example"></b-form-select>-->
<!--          </b-col>-->
          <b-col md="4">
            <div class="d-flex justify-content-end buttons">
              <b-button
                  size="lg"
                  class="mt-4"
                  variant="outline-primary"
                  @click="openModal"
              ><i class='bx bx-plus'> {{$t('message.Add')}}</i>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <div class="mt-5">
          <b-card style="width: 90%; margin: 0 auto;">
            <b-table
                responsive
                striped
                hover
                :items="users"
                :fields="fields">
              <template #cell(action)="{item}">
                <b-button variant="warning" size="sm" @click="getEdit(item.id)">
                  <i class="bx bx-pencil"></i>
                </b-button>
              </template>
            </b-table>
            <div class="d-flex justify-content-end mt-3">
              <b-pagination
                  v-model="pagination.page"
                  hide-goto-end-buttons
                  :total-rows="total"
                  :per-page="pagination.pageSize"
                  @input="fetchUsers()"
              />
            </div>
          </b-card>
        </div>
        <b-modal v-model="FormModal" hide-footer>
          <Form :id="id" @saved="saved"></Form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getRoles, getUsers} from "../../../../../../api/users"
import Form from './Form'
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";


export default {
  name: "Users",
  components: {
    HorizontalTopbarInside,
    Form,
    SideBar
  },
  data() {
    return {
      id:null,
      isMenuCondensed: false,
      FormModal: false,
      users: [],
      pagination: {
        page: 1,
        pageSize: 20,
      },
      total: 1,
      fields: [
        {
          key:'id',
          label: this.$t('message.Id')
        },
        {
          key: "name",
          label: this.$t('message.Username')
        },
        {
          key:'firstname',
          label: this.$t('message.First_name')
        },
        {
          key:'lastname',
          label: this.$t('message.Last_name')
        },
        {
          key:'email',
          label: this.$t('message.Email')
        },
        {
          key:'mobile',
          label: this.$t('message.Mobile_number')
        },
        {
          key:'role_id',
          label: this.$t('message.Role')
        },
        {
          key:'action',
          label: this.$t('message.Action')
        },
      ],
      roles: [],
      role_id: null,
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchUsers()
    this.fetchRoles()
  },
  methods: {
    fetchUsers() {
      getUsers({role_id: this.role_id}).then(res => {
        this.users = res.data.data.data;
        this.total = res.data.data.total
      })
    },
    fetchRoles() {
      getRoles().then(res => {
        this.roles = res.data.data;
      })
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    handlePush(){
      this.$router.push({name: 'addjob'})
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
    openModal() {
      this.FormModal = true;
    },
    saved() {
      this.FormModal = false;
      this.fetchUsers();
    },
    getEdit(id) {
      this.id = id;
      this.FormModal = true;
    }
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #185d89;
}
.buttons{
  margin-right: 50px;
}
</style>



